export const EVENTS_CUSTOM_EVENT_NAME = 'skyEventsCustomEvent';
export const EVENTS_BUFFER_DELAY_MS = 10;
